export default __webpack_public_path__ + "static/media/rounded-gym.3d2145ae.svg";